import { combineReducers } from 'redux';

import appointments from './appointments';

export default combineReducers({
  appointments,
});
